import React, { useEffect } from "react";
import { ProviderInterface } from "src/store/callrecorder/providersSlice";

import { Button, Form, Input, Select, Switch } from "antd";

interface propsInterface {
  params?: ProviderInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='name' label="Name" rules={[{ required: true, message: 'Name is required' }]}>
        <Input placeholder='Provider name' />
      </Form.Item>

      <Form.Item label="Active" name='is_active' valuePropName='checked'>
        <Switch
          checkedChildren='active'
          unCheckedChildren='inactive'
        />
      </Form.Item>

      <Form.Item label="Toll Free" name='toll_free' valuePropName='checked'>
        <Switch
          checkedChildren='yes'
          unCheckedChildren='no'
        />
      </Form.Item>

      <Form.Item label="Call Verify" name='call_verify' valuePropName='checked'>
        <Switch
          checkedChildren='yes'
          unCheckedChildren='no'
        />
      </Form.Item>

      <Form.Item name='blocked_destinations' label="Blocked Destinations">
        <Select
          mode="tags"
          placeholder='Enter country codes (e.g. US, GB)'
          tokenSeparators={[',', ' ']}
        />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
